import React from 'react'
import { Header1, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors } from '../../styles/Variables'

const HeaderContent = ({ handleClick }) => {
  return (
    <>
      <Header1
        color={gsColors.salmon}
        className="web-header-text"
        margin="0 0 24px"
      >
        CORPORATE
        <br />
        EVENTS
      </Header1>
      <Header1 color={gsColors.salmon} className="mobile-header-text">
        CORPORATE EVENTS
      </Header1>
      <Text
        color={gsColors.salmon}
        lineHeight="138%"
        fontSize={22}
        margin="0 0 48px"
      >
        Put glam to work for your brand. We make it easy to create an elevated
        experience for clients, employees, partners, and VIPs.
      </Text>
      <Button
        onClick={handleClick}
        large
        color={gsColors.salmon}
        style={{ color: gsColors.cobalt }}
      >
        Get Started
      </Button>
    </>
  )
}

export default HeaderContent
